import AwardSeal from '@/components/feature/AwardSeal';
import { businessRateAward } from '@/mocks/awards';

export default function CredentialsStrip() {
  return (
    <section id="credentials" className="w-full py-12 md:py-16 bg-cream-50 border-y border-cream-200">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          {/* The three marks */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5 mb-10 md:mb-12">
            {/* BusinessRate seal */}
            <div className="relative">
              <div className="absolute -inset-3 rounded-[2.5rem] bg-gold-400/10 blur-2xl"></div>
              <AwardSeal compact className="relative h-full" />
            </div>

            {/* BBB A+ */}
            <div className="flex h-full flex-col items-center justify-center rounded-[2rem] border border-cream-300 bg-white px-5 py-7 shadow-[0_16px_44px_rgba(8,30,54,0.07)]">
              <div className="w-28 h-14 mx-auto mb-4 flex items-center justify-center">
                <img
                  src="https://mlhdhysslvu0.i.optimole.com/w:auto/h:auto/q:mauto/ig:avif/https://leavittpeakpress.com/wp-content/uploads/2025/02/BBB-A-Logo.png"
                  alt="Better Business Bureau A+ rating logo"
                  title="Better Business Bureau A+ rating — Leavitt Peak Press"
                  className="max-w-full max-h-full object-contain"
                />
              </div>
              <div className="inline-flex items-center gap-1.5 px-3 py-1 bg-gold-500 text-white rounded-full mb-3">
                <span className="text-lg font-black leading-none">A+</span>
                <span className="text-[10px] font-semibold uppercase tracking-wider">Rating</span>
              </div>
              <p className="text-[10px] font-semibold uppercase tracking-[0.18em] text-navy-500 leading-relaxed text-center">
                Better Business Bureau
                <br />
                Accredited since day one
              </p>
            </div>

            {/* IPG */}
            <div className="flex h-full flex-col items-center justify-center rounded-[2rem] border border-cream-300 bg-white px-5 py-7 shadow-[0_16px_44px_rgba(8,30,54,0.07)]">
              <div className="w-28 h-14 mx-auto mb-4 flex items-center justify-center">
                <img
                  src="https://mlhdhysslvu0.i.optimole.com/w:auto/h:auto/q:mauto/ig:avif/https://leavittpeakpress.com/wp-content/uploads/2025/02/1fcbdb1f-0ca9-4617-be32-aa6039855d10.jpg"
                  alt="Independent Publishers Group logo"
                  title="Independent Publishers Group membership — Leavitt Peak Press"
                  className="max-w-full max-h-full object-contain"
                />
              </div>
              <div className="inline-flex items-center gap-1.5 px-3 py-1 bg-navy-500 text-white rounded-full mb-3">
                <i className="ri-building-4-line text-[10px]"></i>
                <span className="text-[10px] font-semibold uppercase tracking-wider">Proud Member</span>
              </div>
              <p className="text-[10px] font-semibold uppercase tracking-[0.18em] text-navy-500 leading-relaxed text-center">
                Independent Publishers Group
                <br />
                Publishing Member
              </p>
            </div>
          </div>

          {/* Copy */}
          <div className="text-center">
            <p className="text-xs font-medium text-gold-600 uppercase tracking-[0.2em] mb-3">
              Recognized, Accredited &amp; Represented
            </p>
            <h2 className="text-2xl md:text-3xl font-bold text-navy-900 mb-3 leading-tight">
              Top 10 Publisher 2026, an A+ since day one,{' '}
              <span className="text-gold-600">and a proud IPG member</span>
            </h2>
            <p className="text-sm md:text-base text-navy-700 leading-relaxed mb-5 max-w-3xl mx-auto">
              BusinessRate named Leavitt Peak Press a <strong>Top 10 Award Winner for 2026</strong> in the Top Publisher
              category for Los Angeles County, dated {businessRateAward.dateAwarded}. Separately, the Better Business
              Bureau has rated us <strong>A+</strong> every day since we opened. And we hold membership in the{' '}
              <strong>Independent Publishers Group (IPG)</strong>, the distributor behind many independent presses. Each
              one is documented, and each can be checked without asking us for anything.
            </p>

            <div className="flex flex-wrap items-center justify-center gap-2 mb-6">
              <span className="inline-flex items-center gap-2 px-3 py-1 bg-white border border-cream-300 rounded-full">
                <i className="ri-award-line text-gold-600 text-sm"></i>
                <span className="text-xs font-medium text-navy-700">Award code {businessRateAward.awardCode}</span>
              </span>
              <span className="inline-flex items-center gap-2 px-3 py-1 bg-white border border-cream-300 rounded-full">
                <i className="ri-map-pin-2-line text-gold-600 text-sm"></i>
                <span className="text-xs font-medium text-navy-700">Los Angeles County</span>
              </span>
              <span className="inline-flex items-center gap-2 px-3 py-1 bg-white border border-cream-300 rounded-full">
                <i className="ri-google-fill text-gold-600 text-sm"></i>
                <span className="text-xs font-medium text-navy-700">Selected on Google review data</span>
              </span>
              <span className="inline-flex items-center gap-2 px-3 py-1 bg-white border border-cream-300 rounded-full">
                <i className="ri-building-4-line text-gold-600 text-sm"></i>
                <span className="text-xs font-medium text-navy-700">IPG member</span>
              </span>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="/ratings"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3.5 text-sm font-semibold text-white bg-navy-500 rounded-full hover:bg-navy-600 transition-all duration-300 hover:scale-105 whitespace-nowrap"
              >
                <i className="ri-shield-check-line"></i>
                See Our Credentials
              </a>
              <a
                href={businessRateAward.issuerUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3.5 text-sm font-medium text-navy-500 border border-navy-300 rounded-full hover:bg-navy-50 hover:border-navy-500 transition-all duration-300 hover:scale-105 whitespace-nowrap"
              >
                <i className="ri-external-link-line"></i>
                Verify at BusinessRate
              </a>
              <a
                href="https://www.ipgbook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3.5 text-sm font-medium text-navy-500 border border-navy-300 rounded-full hover:bg-navy-50 hover:border-navy-500 transition-all duration-300 hover:scale-105 whitespace-nowrap"
              >
                <i className="ri-external-link-line"></i>
                IPG Membership
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}